export const abrirVisor = (doc) => window.dispatchEvent(new CustomEvent("aldia-visor", { detail: doc }));
